module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/info-154a7c52c1bd0af66c03d0bf4cc85a2f.svg";